/**
 * 右键菜单
 * 2019-7-31
 * Bai.Zhiming
 */
angular.module("contextmenuModule", []).
directive("contextmenu", ['$templateRequest', '$compile', '$q', function($templateRequest, $compile, $q) {
    return {
        restrict: "A",
        replace: false,
        scope: false,
        link(scope, $element, $attrs) {
            initStatus();
            initData();
            /**
             * [getTemplate description] 获取模板
             * @return {[type]} [description]
             */
            function getTemplate() {
                let deffer = $q.defer();
                let templateUrl = $attrs["templateUrl"],
                    isCustomTemplate = false;
                if (templateUrl) {
                    isCustomTemplate = true;
                } else {
                    templateUrl = "./IM/directive/contextmenu/contextmenu_tpl.html";
                }
                $templateRequest(templateUrl).then(template => {
                    if (isCustomTemplate) {
                        template = `<div class="contextmenu">${template}</div>`;
                    }
                    scope.contextmenuStatus.$template = $compile($(template))(scope);
                    $("body").append(scope.contextmenuStatus.$template);
                    deffer.resolve();
                });
                return deffer.promise;
            }
            /**
             * [initClick description] 初始化点击事件
             * @return {[type]} [description]
             */
            function initClick() {
                $element[0].oncontextmenu = rightClick;
            }
            /**
             * [initDismiss description] 初始化消除事件
             * @return {[type]} [description]
             */
            function initDismiss() {
                $("body").bind("mouseup", dismiss);
                /**
                 * [dismiss description] 消除
                 * @return {[type]} [description]
                 */
                function dismiss(e) {
                    if(e.button==2) return;
                    scope.contextmenuStatus.$template.hide();
                }
                scope.$on("$destroy", () => {
                    $("body").unbind("mouseup", dismiss);
                })
            }
            /**
             * [initDestroy description] 初始化销毁事件
             * @return {[type]} [description]
             */
            function initDestroy() {
                scope.$on("$destroy", () => {
                    scope.contextmenuStatus.$template.remove();
                });
            }
            /**
             * [rightClick description] 右键单击
             * @return {[type]} [description]
             */
            function rightClick(e) {
                let clientX = e.clientX;
                let clientY = e.clientY;
                scope.contextmenuStatus.$template.css({
                    top: clientY,
                    left: clientX,
                    display: "block"
                });
                return false;
            }
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.contextmenuStatus = {
                    $template: ''
                };
                scope.contextmenuData = {};
                getTemplate().then(() => {
                    initClick();
                    initDismiss();
                    initDestroy();
                });
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {}
        }
    };
}]);